export const businessProfileObject = (doc) => {
    switch (doc.industryType) {
        case "ANIMALS":
            return new AnimalBusinessObject(doc);
        case "PLANTS":
            return new PlantBusinessObject(doc);
        default:
            return new BusinessSharedObject(doc);
    }
};
const initialState = {
    companyName: '',
    companyNumber: '',
    brandDescription: '',
    businessCountry: '',
    cuig: '',
    location: [],
    permits: [],
    licenseExpiryDate: '',
    licenseNumber: '',
    optiweigh: {
        clientId: '',
        apiKey: '',
        agliveKey: '',
        interval: '',
    }
};
class BusinessSharedObject {
    constructor(doc) {
        this.doc = doc;
    }
    isCountry(country) {
        return this.doc.businessCountry === country || (country === 'Australia' && !this.doc.businessCountry);
    }
    isIndustry(industry) {
        return this.doc.industryType.toLowerCase() === industry.toLowerCase();
    }
    isType(type) {
        return type in this.doc;
    }
    isLivestock() {
        return this.isIndustry('ANIMALS');
    }
    checkOptiweighModified(editDoc, useOptiweigh) {
        return false;
    }
    isPlants() {
        return this.isIndustry('PLANTS');
    }
    isOptiweigh() {
        return this.isIndustry('ANIMALS') && this.isType('optiweigh');
    }
    isAustralia() {
        return this.isCountry('Australia');
    }
    isArgentina() {
        return this.isCountry('Argentina');
    }
    numLocations() {
        var _a, _b;
        return ((_b = (_a = this.doc) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.length) || 0;
    }
    locationTemplate() {
        const locationTemplate = {
            locationNickname: '',
            country: '',
            address: '',
            postcode: '',
            town: '',
            state: '',
            locationType: '',
            PICAddress: '',
            LPAUserID: '',
            LPAPassword: '',
            NLISUserID: '',
            NLISPassword: '',
            locationId: ''
        };
        return locationTemplate;
    }
    initialValidationState() {
        var _a;
        const initialObjectState = initialState;
        if ((_a = this.doc) === null || _a === void 0 ? void 0 : _a.location) {
            initialObjectState.location = Array.from({ length: this.doc.location.length }, _ => this.locationTemplate());
        }
        return initialObjectState;
    }
}
class AnimalBusinessObject extends BusinessSharedObject {
    constructor(doc) {
        super(doc);
    }
    checkOptiweighModified(editDoc, useOptiweigh) {
        let modified = false;
        if (!editDoc.optiweigh) {
            return modified;
        }
        const currDoc = this.doc;
        Object.entries(editDoc.optiweigh).forEach(([key, val]) => {
            if ((useOptiweigh &&
                (!currDoc.optiweigh ||
                    currDoc.optiweigh[key] !== val)) ||
                (!useOptiweigh &&
                    currDoc.optiweigh &&
                    currDoc.optiweigh[key])) {
                modified = true;
            }
        });
        return modified;
    }
}
class PlantBusinessObject extends BusinessSharedObject {
    constructor(doc) {
        super(doc);
    }
    initialValidationState() {
        const permitsTemplate = {
            permitNumber: '',
            permitExpiryDate: ''
        };
        let initialObjectState = super.initialValidationState();
        const currDoc = this.doc;
        if (currDoc.permits) {
            const permitList = Array.from({ length: currDoc.permits.length }, _ => (Object.assign({}, permitsTemplate)));
            return Object.assign(Object.assign({}, initialObjectState), { permits: permitList });
        }
        return initialObjectState;
    }
}
